import React, { useState, useEffect, useRef } from "react";
import "./EIC.css";
// import logo from "../src/pic/mic.png.png";
// import qr from "../src/pic/qr1.png";
import SunRise from "../src/pic/1f305.gif";
import SunSet from "../src/pic/1f304.gif";
import paypal from "../src/pic/paypal.png";
import zelle from "../src/pic/zelle.png";
import MICLogo from "../src/pic/MICLogo.png";
import background from "./pic/pattern.png";
import audioSong from "./pic/adan.mp3";

//email:micnytv@gmail.com
// Password: Micnytv@gmail.com@123

// samsung tv login: micnytv@gmail.com
// samsung tv password: MED$%#GehGHdf34

import ddata from "./ddddata.json";
import dataForFiveTimesColorBackground from "./dataForFiveTimesColor.json";
// Put azan.mp3 in public folder
// const azanAudio = new Audio("/azan.mp3");

//

/*
  PrayerIqamahApp.jsx
  - Plain React (JavaScript)
  - Put your schedule data in `scheduleData`
  - When an Iqamah is active, sets document.body background to red for the configured duration
  - Shows a full-screen countdown overlay while active
*/

// Use your provided data (MM/DD/YY). The parser auto-detects DD/MM/YY if needed.

// Helper: parse date string (MM/DD/YY or DD/MM/YY auto-detect) + time "H:mm" -> Date (local timezone)
function parseDateTimeFlexible(dateStr, timeStr) {
  if (!dateStr || !timeStr) return null;
  const parts = dateStr.split("/").map((p) => Number(p));
  if (parts.length !== 3) return null;
  let month, day, year;
  // auto-detect: if first part > 12 assume DD/MM/YY, else MM/DD/YY
  if (parts[0] > 12) {
    // DD/MM/YY
    day = parts[0];
    month = parts[1];
    year = 2000 + parts[2];
  } else {
    // MM/DD/YY
    month = parts[0];
    day = parts[1];
    year = 2000 + parts[2];
  }
  const [hour, minute] = timeStr.split(":").map((s) => Number(s));
  const dt = new Date(year, month - 1, day, hour, minute, 0, 0);
  return dt;
}

// returns duration in minutes for a given prayer key and day object
function getDurationMinutes(prayerKey, dayObj) {
  // prayerKey is like "Fajr_Iqamah", "Dhuhr_Iqamah", etc.
  const base =
    {
      Fajr_Iqamah: 15,
      Dhuhr_Iqamah: 10,
      Asr_Iqamah: 10,
      Maghrib_Iqamah: 12,
      Isha_Iqamah: 15,
    }[prayerKey] || 10;

  // special Friday rule: if day is Friday and prayer is Dhuhr => 60
  if (
    prayerKey === "Dhuhr_Iqamah" &&
    String(dayObj.Day || "")
      .trim()
      .toLowerCase() === "friday"
  ) {
    return 45;
  }
  return base;
}
//উপরের পুরা টা হচ্ছে ১০ মিইট কালো স্ক্রীন এর জন্য

// Nicher pura ta arabic date er jonno

// Returns mathematic mod, not javascript mod
// e.g. gmod(-3, 2) returns 1, whereas -3%2 returns -1
function gmod(n, m) {
  return ((n % m) + m) % m;
}

/* @param {Date}   date   - optional, default is today
 ** @param {number} adjust - optiona, days to adjust date by
 */
function kuwaiticalendar(date, adjust) {
  var today = date ? new Date(+date) : new Date();
  if (adjust) {
    today.setDate(today.getDate() + +adjust);
  }

  var day = today.getDate();
  var month = today.getMonth();
  var year = today.getFullYear();
  var m = month + 1;
  var y = year;

  if (m < 3) {
    y -= 1;
    m += 12;
  }

  var a = Math.floor(y / 100);
  var b = 2 - a + Math.floor(a / 4);

  if (y < 1583) b = 0;
  if (y == 1582) {
    if (m > 10) b = -10;
    if (m == 10) {
      b = 0;
      if (day > 4) b = -10;
    }
  }

  var jd =
    Math.floor(365.25 * (y + 4716)) +
    Math.floor(30.6001 * (m + 1)) +
    day +
    b -
    1524;

  b = 0;
  if (jd > 2299160) {
    a = Math.floor((jd - 1867216.25) / 36524.25);
    b = 1 + a - Math.floor(a / 4);
  }

  var bb = jd + b + 1524;
  var cc = Math.floor((bb - 122.1) / 365.25);
  var dd = Math.floor(365.25 * cc);
  var ee = Math.floor((bb - dd) / 30.6001);
  day = bb - dd - Math.floor(30.6001 * ee);
  month = ee - 1;

  if (ee > 13) {
    cc += 1;
    month = ee - 13;
  }
  year = cc - 4716;
  var wd = gmod(jd + 1, 7) + 1;

  var iyear = 10631 / 30;
  var epochastro = 1948084;
  var epochcivil = 1948085;

  var shift1 = 8.01 / 60;

  var z = jd - epochastro;
  var cyc = Math.floor(z / 10631);
  z = z - 10631 * cyc;
  var j = Math.floor((z - shift1) / iyear);
  var iy = 30 * cyc + j;
  z = z - Math.floor(j * iyear + shift1);
  var im = Math.floor((z + 28.5001) / 29.5);

  if (im == 13) im = 12;
  var id = z - Math.floor(29.5001 * im - 29);

  return [
    day, //calculated day (CE)
    month - 1, //calculated month (CE)
    year, //calculated year (CE)
    jd - 1, //julian day number
    wd - 1, //weekday number
    id, //islamic date
    im - 1, //islamic month
    iy, //islamic year
  ];
}

function writeIslamicDate(date = new Date(), adjustment = 0) {
  // Auto-adjust for US timezones (NY, EST/EDT)
  const tzOffsetHours = date.getTimezoneOffset() / 60; // NY = 4 or 5
  const autoAdjust = tzOffsetHours >= 4 ? -1 : 0;

  const wdNames = [
    "Ahad",
    "Ithnin",
    "Thulatha",
    "Arbaa",
    "Khams",
    "Jumuah",
    "Sabt",
  ];

  const iMonthNames = [
    "Muharram",
    "Safar",
    "Rabi'ul Awwal",
    "Rabi'ul Akhir",
    "Jumadal Ula",
    "Jumadal Akhira",
    "Rajab",
    "Sha'ban",
    "Ramadan",
    "Shawwal",
    "Dhul Qa'ada",
    "Dhul Hijja",
  ];

  const iDate = kuwaiticalendar(date, adjustment + autoAdjust);

  return (
    wdNames[iDate[4]] +
    ", " +
    iDate[5] +
    " " +
    iMonthNames[iDate[6]] +
    " " +
    iDate[7] +
    " AH"
  );
}

// No date or adjust
// console.log(writeIslamicDate());
// No date, adjust to tomorrow
// console.log(writeIslamicDate(undefined, 1));
// Date for 1 Jan 2017
// console.log(writeIslamicDate(new Date(2017, 0, 1)));
// Date for 1 Jan 2017, adjust by -1 day
// console.log(writeIslamicDate(new Date(2017, 0, 1), -1));

// Uporer pura ta arabic date er jonno
function excelDateToJSDate(excelSerial) {
  const excelEpoch = new Date(1900, 0, 1); // Jan 1, 1900
  const msPerDay = 1000 * 60 * 60 * 24;
  const daysOffset = excelSerial - 1; // Excel counts Jan 1, 1900 as day 1
  const jsDate = new Date(excelEpoch.getTime() + daysOffset * msPerDay);
  return jsDate;
}
//Convert Excel serial number to JS Date up

// Get next Friday from today
const getNextFriday = () => {
  const today = new Date();
  const day = today.getDay(); // Sunday = 0, Friday = 5
  const daysToAdd = (5 - day + 7) % 7 || 7; // Always go forward
  const nextFriday = new Date(today);
  nextFriday.setDate(today.getDate() + daysToAdd);
  return nextFriday;
};
//above finds next fiday

const formatTime = (date) => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;
  const secondsStr = seconds < 10 ? "0" + seconds : seconds;
  return hours + ":" + minutesStr + ":" + secondsStr + " " + ampm;
};
// Convert Excel time (e.g. 0.625) to AM/PM format below
function excelTimeToAMPM(excelTime) {
  const totalMinutes = Math.round(excelTime * 24 * 60);
  let hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;

  const pad = (n) => String(n).padStart(2, "0");
  return `${hours}:${pad(minutes)}:00 ${ampm}`;
}
//Convert Excel time (e.g. 0.625) to AM/PM format above

// Convert Excel decimal (fraction of a day) -> HH:mm:ss object
// function excelToSeconds(decimal) {
//   return Math.floor(decimal * 24 * 60 * 60);
// }

function timeToSeconds(timeStr) {
  const [h, m] = timeStr.split(":").map(Number);
  return h * 3600 + m * 60;
}

const App = () => {
  //below is for blink function 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  const [isVisible, setIsVisible] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [hijriDate, setHijriDate] = useState("");
  const audioRef = useRef(null);
  //below code find what is the day today
  const [dayName, setDayName] = useState(() => {
    const today = new Date();
    return today.toLocaleDateString("en-US", { weekday: "long" });
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const today = new Date();
      setDayName(today.toLocaleDateString("en-US", { weekday: "long" }));
    }, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);
  //above  code find what is the day today
  // useEffect(() => {
  //   const toggleVisibility = () => {
  //     setIsVisible((prevVisible) => !prevVisible);
  //   };

  //   const blinkInterval = setInterval(toggleVisibility, 150);

  //   return () => clearInterval(blinkInterval);
  // }, [150]);
  //above is for blink function 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  //below finds todays date and todays data to display🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  //excel formate find todays date below
  function dateToExcelSerial(date = new Date()) {
    const excelStartDate = new Date(1900, 0, 1); // Jan 1, 1900
    const utcDate = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
    );
    const utcStart = Date.UTC(
      excelStartDate.getFullYear(),
      excelStartDate.getMonth(),
      excelStartDate.getDate(),
    );

    const diffInDays = Math.floor((utcDate - utcStart) / (1000 * 60 * 60 * 24));
    return diffInDays + 1;
  }
  const todaySerial = dateToExcelSerial(); // returns 45663 on April 20, 2025
  const todaySerial2 = dateToExcelSerial() + 1; // returns 45664 on April 21, 2025
  const todaySerial3 = dateToExcelSerial() + 2; // returns 45665 on April 22, 2025
  const todaySerial4 = dateToExcelSerial() + 3; // returns 45666 on April 23, 2025
  // console.log("Today in Excel format:", todaySerial);
  // console.log("Tomorrow in Excel format:", todaySerial2);
  // console.log("Tomorrow in Excel format:", todaySerial3);
  // console.log("Tomorrow in Excel format:", todaySerial4);
  //excel formate find todays date above

  const todaysItems = ddata.filter((item) => item.Date === todaySerial + 1);
  const todaysItems2 = ddata.filter((item) => item.Date === todaySerial2 + 1);
  const todaysItems3 = ddata.filter((item) => item.Date === todaySerial3 + 1);
  const todaysItems4 = ddata.filter((item) => item.Date === todaySerial4 + 1);
  // console.log(todaysItems);

  const [bb] = todaysItems;
  const [bb2] = todaysItems2;
  const [bb3] = todaysItems3;
  const [bb4] = todaysItems4;
  //main data has all data inside bb
  // console.log(bb);

  //   delete bb.Day;

  const keys_to_keep = [
    "Fajr",
    "Fajr_Iqamah",
    "Dhuhr",
    "Dhuhr_Iqamah",
    "Asr",
    "Asr_Iqamah",
    "Maghrib",
    "Maghrib_Iqamah",
    "Isha",
    "Isha_Iqamah",
  ];

  const keys_to_keep2 = [
    "Fajr_Iqamah",
    "Dhuhr_Iqamah",
    "Asr_Iqamah",
    "Maghrib_Iqamah",
    "Isha_Iqamah",
  ];

  var result = todaysItems.map((obj) =>
    Object.fromEntries(
      keys_to_keep2
        .map((key) => obj.hasOwnProperty(key) && [key, obj[key]])
        .filter(Boolean),
    ),
  );
  const [kk] = result;
  // console.log(kk); // only 5 times azan data
  //up finds todays date and todays data to display🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  //🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽 count down for 5 prayers below🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  const [nextPrayer, setNextPrayer] = useState({});
  const [countdown, setCountdown] = useState("00:00:00");
  const [isPlayingAzan, setIsPlayingAzan] = useState(false);
  //below finds next fiday
  const nextFriday = getNextFriday();
  const excelDate = dateToExcelSerial(nextFriday);
  // console.log(excelDate);
  //above finds next fiday
  const nextFridayIs = ddata.filter((item) => item.Date === excelDate);
  const [nextFridayInExcel] = nextFridayIs.map((a) => a.Date);
  //   console.log(nextFridayInExcel);
  const [nextFridayInExcelToObject] = ddata.filter(
    (item) => item.Date === nextFridayInExcel,
  );
  const fridayExcelToRegular = nextFridayInExcelToObject.Date;
  const convertedDate = excelDateToJSDate(fridayExcelToRegular);
  const formatted = convertedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const a = new Date();
  // const localDateString = today.toLocaleDateString();
  //   const today = a.toISOString().split("T")[0];
  const todaysDateIs = a.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  // console.log(a);
  const tomorrow = new Date(a);
  tomorrow.setDate(a.getDate() + 1);
  // console.log(tomorrow.toDateString());

  const DayAfterTomorrow = new Date(a);
  DayAfterTomorrow.setDate(a.getDate() + 2);
  // console.log(DayAfterTomorrow.toDateString());

  const DayAfterTomorrowTomorrow = new Date(a);
  DayAfterTomorrowTomorrow.setDate(a.getDate() + 3);
  // console.log(DayAfterTomorrowTomorrow.toDateString());

  const DayAfterTomorrowTomorrowTomorrow = new Date(a);
  DayAfterTomorrowTomorrowTomorrow.setDate(a.getDate() + 4);
  // console.log(DayAfterTomorrowTomorrowTomorrow.toDateString());

  const DayAfterTomorrowTomorrowTomorrowTomorrow = new Date(a);
  DayAfterTomorrowTomorrowTomorrowTomorrow.setDate(a.getDate() + 5);
  // console.log(DayAfterTomorrowTomorrowTomorrowTomorrow.toDateString());

  //   console.log(todaysDateIs);

  const convertToMinutes = (excelTime) => excelTime * 24 * 60;

  const formatTimeAMPM = (excelTime) => {
    const totalMinutes = convertToMinutes(excelTime);

    let hours = Math.floor(totalMinutes / 60);
    let minutes = Math.round(totalMinutes % 60);

    // ⭐ Normalize 60 minutes → next hour
    if (minutes === 60) {
      minutes = 0;
      hours += 1;
    }

    const h = hours % 12 || 12;
    const m = String(minutes).padStart(2, "0");
    const suffix = hours >= 12 ? "PM" : "AM";

    return `${h}:${m} ${suffix}`;
  };

  useEffect(() => {
    const prayerList = Object.entries(kk).map(([label, time]) => ({
      label,
      time,
      minutes: convertToMinutes(time),
    }));
    const interval = setInterval(() => {
      if (isPlayingAzan) return;

      const now = new Date();
      const nowMinutes =
        now.getHours() * 60 + now.getMinutes() + now.getSeconds() / 60;

      let next = null;
      let minDiff = Infinity;

      for (let p of prayerList) {
        let diff = p.minutes - nowMinutes;
        if (diff < 0) diff += 1440;
        if (diff < minDiff) {
          minDiff = diff;
          next = p;
        }
      }

      const totalSeconds = Math.floor(minDiff * 60);

      if (totalSeconds <= 0) {
        // Countdown reached zero, play azan
        // playAzan(() => {
        //   // After azan, re-run logic to find next prayer
        //   const updatedNow = new Date();
        //   const updatedNowMinutes =
        //     updatedNow.getHours() * 60 + updatedNow.getMinutes();
        //   let upcoming = prayerList.find(
        //     (p) => convertToMinutes(p.time) > updatedNowMinutes
        //   );
        //   if (!upcoming) upcoming = prayerList[0]; // loop to Fajr
        //   setNextPrayer(upcoming);
        // });
      } else {
        setNextPrayer(next);
        const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
          2,
          "0",
        );
        const s = String(totalSeconds % 60).padStart(2, "0");
        setCountdown(`${h}:${m}:${s}`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isPlayingAzan]);

  //below is for per second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  //above is for per second

  //below is for arabic date
  useEffect(() => {
    const today = new Date();
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      calendar: "islamic",
      numberingSystem: "latn",
    };
    const hijriFormatter = new Intl.DateTimeFormat("en-US", options);
    const formattedHijri = hijriFormatter.format(today);
    setHijriDate(formattedHijri);
  }, []);
  //above is for arabic date

  // below is for 5 box and what time prayer is now is red and rest is blue

  const [currentPrayer, setCurrentPrayer] = useState("");

  useEffect(() => {
    const checkPrayer = () => {
      const today = new Date();
      const todayDate = today.toLocaleDateString("en-US"); // "12/14/2025"
      // Your dataset uses "12/14/25" instead of "2025"
      const todayShort = todayDate.replace(/(\d+)$/, (y) => y.slice(-2)); // "12/14/25"

      // Find today's row
      const todayData = dataForFiveTimesColorBackground.find(
        (d) => d.Date === todayShort,
      );

      // console.log(todayDate);
      // console.log(todayData);
      const fajr = timeToSeconds(todayData.Fajr);
      const dhuhr = timeToSeconds(todayData.Dhuhr);
      const asr = timeToSeconds(todayData.Asr);
      const maghrib = timeToSeconds(todayData.Maghrib);
      const isha = timeToSeconds(todayData.Isha);

      const nowSec =
        today.getHours() * 3600 + today.getMinutes() * 60 + today.getSeconds();

      if (nowSec >= fajr && nowSec < dhuhr) {
        setCurrentPrayer("Fajr");
      } else if (nowSec >= dhuhr && nowSec < asr) {
        setCurrentPrayer("Dhuhr");
      } else if (nowSec >= asr && nowSec < maghrib) {
        setCurrentPrayer("Asr");
      } else if (nowSec >= maghrib && nowSec < isha) {
        setCurrentPrayer("Maghrib");
      } else {
        // Isha until next day's Fajr
        setCurrentPrayer("Isha");
      }
    };

    checkPrayer();
    const interval = setInterval(checkPrayer, 1000);
    return () => clearInterval(interval);
  }, [dataForFiveTimesColorBackground]);

  // console.log(currentPrayer);

  // above is for 5 box and what time prayer is now is red and rest is blue
  //below useeffect will refresh page everyday at 12:05AM
  useEffect(() => {
    // Function to get the next 12:05 AM
    const getNextRefreshTime = () => {
      const now = new Date();
      const next = new Date();
      next.setHours(0, 5, 0, 0); // 12:05 AM today
      // next.setHours(19, 35, 0, 0);
      if (now > next) {
        next.setDate(next.getDate() + 1); // if past 12:05, schedule for tomorrow
      }
      return next;
    };

    const nextRefresh = getNextRefreshTime();
    const timeUntilRefresh = nextRefresh.getTime() - Date.now();

    const timer = setTimeout(() => {
      window.location.reload();
    }, timeUntilRefresh);

    return () => clearTimeout(timer);
  }, []);

  //above useeffect will refresh page everyday at 12:05AM

  //উপরের পুরা টা হচ্ছে ১০ মিইট কালো স্ক্রীন এর জন্য
  //
  const [now, setNow] = useState(new Date());
  const [activeWindow, setActiveWindow] = useState(null); // { prayerName, day, start, end }
  const beepPlayed = useRef(false);

  // tick every second
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  // on every tick check if any iqamah window is active (across scheduleData)
  useEffect(() => {
    // find first active window (if any)
    for (let i = 0; i < dataForFiveTimesColorBackground.length; i++) {
      const day = dataForFiveTimesColorBackground[i];
      const keys = [
        "Fajr_Iqamah",
        "Dhuhr_Iqamah",
        "Asr_Iqamah",
        "Maghrib_Iqamah",
        "Isha_Iqamah",
      ];
      for (let k = 0; k < keys.length; k++) {
        const key = keys[k];
        const timeStr = day[key];
        if (!timeStr) continue;
        const start = parseDateTimeFlexible(day.Date, timeStr);
        if (!start || isNaN(start.getTime())) continue;
        const durMin = getDurationMinutes(key, day);
        const end = new Date(start.getTime() + durMin * 60 * 1000);
        if (now >= start && now < end) {
          // if already same window, keep it; otherwise set new
          if (
            !activeWindow ||
            activeWindow.start.getTime() !== start.getTime() ||
            activeWindow.key !== key
          ) {
            setActiveWindow({
              key,
              prayerName: key.replace("_Iqamah", ""),
              day,
              start,
              end,
            });
          }
          return; // found one active, stop searching
        }
      }
    }
    // no active window found => clear
    if (activeWindow) setActiveWindow(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [now /* activeWindow intentionally not in deps to avoid loop */]);

  // apply body background while active and restore on clear/unmount
  useEffect(() => {
    const prevBg = document.body.style.backgroundColor || "";
    const prevColor = document.body.style.color || "";
    if (activeWindow) {
      document.body.style.backgroundColor = "black";
      document.body.style.color = "white";
      // Play sound once
      if (!beepPlayed.current) {
        const audio = new Audio(audioSong);
        audio.play().catch(() => {});
        beepPlayed.current = true;
      }
    } else {
      document.body.style.backgroundColor = prevBg;
      document.body.style.color = prevColor;
    }
    return () => {
      document.body.style.backgroundColor = prevBg;
      document.body.style.color = prevColor;
    };
  }, [activeWindow]);

  // remaining seconds for overlay
  const remainingSeconds = activeWindow
    ? Math.max(
        0,
        Math.ceil((activeWindow.end.getTime() - now.getTime()) / 1000),
      )
    : 0;

  // format mm:ss (or H:MM:SS if long)
  function formatCountdown(sec) {
    if (sec <= 0) return "0:00";
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    if (h > 0) {
      return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    }
    return `${m}:${String(s).padStart(2, "0")}`;
  }
  //উপরের পুরা টা হচ্ছে ১০ মিইট কালো স্ক্রীন এর জন্য
  // console.log(formatTimeAMPM(bb2.Fajr_Iqamah));

  return (
    <>
      <div
        className="container "
        style={{
          height: "100vh",
        }}
      >
        {/* //নিচের পুরা টা হচ্ছে ১০ মিইট কালো স্ক্রীন এর জন্য */}
        {activeWindow && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              background: "black",
              color: "#fff",
              textAlign: "center",
              padding: 20,
            }}
          >
            <div style={{ fontSize: 44, fontWeight: 700, marginBottom: 8 }}>
              {/* 🕌 {activeWindow.key.replace("_Iqamah", "")}} Iqamah */}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                fontSize: 180,
                fontWeight: "bold",
                color: "#260e0e",
                marginTop: "820px",
                // marginBottom: "50px",
              }}
            >
              SILENCE PLEASE
            </div>

            <div
              style={{
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Space Mono, monospace",
                marginLeft: "79.5%",
                marginTop: 810,
              }}
            >
              {/* Now, it is {activeWindow.prayerName} Iqamah time <br />  */}
              Will return in {formatCountdown(remainingSeconds)} minutes
            </div>
            <div
              style={{
                fontSize: 14,
                // marginBottom: "-80px",
                // fontFamily: "Space Mono, monospace",
                marginLeft: "66%",
                // marginTop: 8,
              }}
            >
              {/* Ends at {activeWindow.end.toLocaleTimeString()} */}
              Application Developer: MEHDI HASAN || 845.514.8834 || Message To
              Suggest
            </div>
          </div>
        )}
        {/* //উপরের পুরা টা হচ্ছে ১০ মিনিট  কালো স্ক্রীন এর জন্য */}
        <div
          className="left"
          style={{
            width: "60%",
            height: "100vh",

            filter: "drop-shadow(0 0 2px #6F47D3)",

            // background: "#316997ff",
            // background: "#3d7effff",
            background: "#ffffffff",

            color: "#0070bb",
            // border: "2px solid red",
            float: "left",
          }}
        >
          <div
            className="lontainer wrapper "
            style={{
              marginTop: "-30px",
              // marginBottom: "-10px",
            }}
          >
            <img
              src={MICLogo}
              className="icon-image"
              alt="Left Icon"
              // class=""
              style={{
                height: 70,
                width: 70,
                // marginTop: "-35px",
                // marginRight: "50px",
                //  gap: '100px'
              }}
            />

            <h3
              // className="word"
              // id="myText"
              style={{
                textAlign: "center",
                // marginTop: "1px",
                // marginBottom: "30px",
                fontSize: "40px",
                // fontFamily: "DM Sans, sans-serif",
                fontFamily: "Quicksand, sans-serif",

                fontStyle: "normal",
                // display: 'inline',
                // letterSpacing: -4,
                letterSpacing: "6px",
                color: "#0070bb",
                // textShadow: "2px 2px #1c7a1f",
              }}
            >
              MIDDLETOWN ISLAMIC CENTER
            </h3>
            <img
              src={MICLogo}
              className="icon-image"
              alt="Right Icon"
              style={{
                height: 70,
                width: 70,
                // marginTop: "-35px",
                // marginLeft: "50px",
                //  gap: '100px'
              }}
            />
          </div>
          <div
            className="Table-Title-div"
            style={{
              marginTop: "-32px",
            }}
          >
            <table
              style={{
                width: "100%",

                fontSize: "30px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",

                    // background: "#80CBC4",
                  }}
                >
                  <b> </b>
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",

                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  ATHAN
                </td>

                <td
                  style={{
                    width: "40%",
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                    fontWeight: "bold",
                  }}
                >
                  IQAMAH
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Fajr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                    verticalAlign: "bottom",

                    // background: "#80CBC4",
                  }}
                >
                  <b></b> FAJR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    // fontSize: "90px",
                    fontSize: "46px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {/* 56:56 PM <br /> */}
                  Imsak: {formatTimeAMPM(bb.Fajr)}
                  <br />
                  Athan:{" "}
                  {(() => {
                    const t = formatTimeAMPM(bb.Fajr); // "5:19 AM"
                    const [h, m, ap] = t.split(/[: ]/); // ["5", "19", "AM"]
                    const total =
                      Number(h) * 60 +
                      Number(m) +
                      (ap === "PM" && h !== "12" ? 720 : 0) +
                      10;
                    const newH = ((Math.floor(total / 60) - 1) % 12) + 1;
                    const newM = String(total % 60).padStart(2, "0");
                    const newAP = total < 720 ? "AM" : "PM";
                    return `${newH}:${newM} ${newAP}`;
                  })()}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",
                    fontWeight: "bold",

                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Fajr_Iqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Dhuhr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    fontWeight: "bold",
                    textAlign: "right",
                    verticalAlign: "bottom",
                    fontSize: "40px",
                    // background: "#80CBC4",
                  }}
                >
                  <b></b>DHUHR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Dhuhr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Dhuhr_Iqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Asr" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>ASR
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Asr)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Asr_Iqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Maghrib" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",
                    letterSpacing: -3,
                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>MAGHRIB
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Maghrib)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Maghrib_Iqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div
            className={`box ${
              currentPrayer === "Isha" ? "active bestseller" : ""
            }`}
          >
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>ISHA
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Isha)}
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  {formatTimeAMPM(bb.Isha_Iqamah)}
                </td>
              </tr>
            </table>
          </div>
          <div className="JUMMAH-div">
            <table
              style={{
                width: "100%",
                marginTop: "-2px",
                // border: "none !important",
                // filter: "drop-shadow(0 0 2px #6F47D3)",
              }}
            >
              <tr style={{}}>
                <td
                  style={{
                    width: "20%",
                    fontFamily: "Quicksand, sans-serif",
                    verticalAlign: "bottom",
                    letterSpacing: -3,

                    fontWeight: "bold",
                    textAlign: "right",
                    fontSize: "45px",
                  }}
                >
                  <b></b>JUMUAH
                </td>

                <td
                  style={{
                    width: "40%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    borderRight: "1px solid #dddddd",
                    borderLeft: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  1:15 PM
                </td>

                <td
                  style={{
                    width: "40%",
                    fontSize: "90px",
                    letterSpacing: -4,
                    fontFamily: "Quicksand, sans-serif",
                    textAlign: "center",

                    fontWeight: "bold",
                    // border: "1px solid #dddddd",
                    // background: "#80CBC4",
                  }}
                >
                  1:45 PM
                </td>
              </tr>
            </table>
          </div>
          <table
            style={{
              width: "100%",
              fontSize: "19px",
              border: "none !important",
              filter: "drop-shadow(0 0 2px #6F47D3)",
            }}
          >
            <tr style={{}}>
              <td
                style={{
                  // border: "1px solid #dddddd",
                  textAlign: "center",
                  fontFamily: "Quicksand, sans-serif",
                  // fontWeight: "normal",
                  background: "#ffffffff",
                  // fontSize: "25px",
                  // marginTop: "-40px",
                }}
              >
                Tomorrow:&nbsp;
                {/* <b> */}
                {tomorrow.toLocaleDateString("en-US", {
                  weekday: "long",
                })}
                , {/* <br /> */}
                {tomorrow.getDate()}/
                {tomorrow.toLocaleString("Default", {
                  month: "short",
                })}
                /{tomorrow.getFullYear()}
                {/* </b> */}
              </td>
              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Fajr)}
                  </td> */}

              {formatTimeAMPM(bb.Fajr_Iqamah) ===
              formatTimeAMPM(bb2.Fajr_Iqamah) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",

                    background: "#ffffffff",
                  }}
                >
                  <span> Fajar-Iqama {formatTimeAMPM(bb2.Fajr_Iqamah)} </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    background: "#EA5B6F",
                    width: "120px",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Fajr-Iqama &nbsp; <br />
                    {/* {formatTimeAMPM(bb2.Fajr_Iqamah)} */}
                    {formatTimeAMPM(bb2.Fajr_Iqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in whatsapp.com</marquee>
                    ) : (
                      formatTimeAMPM(bb2.Fajr_Iqamah)
                    )}
                    <b
                      style={
                        {
                          // background: "#0118D8",
                        }
                      }
                    ></b>
                  </span>
                </td>
              )}

              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Dhuhr)}
                  </td> */}

              {formatTimeAMPM(bb.Dhuhr_Iqamah) ===
              formatTimeAMPM(bb2.Dhuhr_Iqamah) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",

                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Dhuhr-Iqama <br /> {formatTimeAMPM(bb2.Dhuhr_Iqamah)}{" "}
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "130px",

                    background: "#F65A83",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Dhuhr-Iqama <br />
                    {/* {formatTimeAMPM(bb2.Dhuhr_Iqamah)} */}
                    {formatTimeAMPM(bb2.Dhuhr_Iqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      formatTimeAMPM(bb2.Dhuhr_Iqamah)
                    )}
                  </span>
                </td>
              )}

              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Asr)}
                  </td> */}

              {formatTimeAMPM(bb.Asr_Iqamah) ===
              formatTimeAMPM(bb2.Asr_Iqamah) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",

                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Asr-Iqama <br /> {formatTimeAMPM(bb2.Asr_Iqamah)}{" "}
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",

                    background: "#F65A83",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Asr-Iqama <br />
                    {/* {formatTimeAMPM(bb2.Asr_Iqamah)} */}
                    {formatTimeAMPM(bb2.Asr_Iqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      formatTimeAMPM(bb2.Asr_Iqamah)
                    )}
                  </span>
                </td>
              )}

              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Maghrib)}
                  </td> */}
              {formatTimeAMPM(bb.Maghrib_Iqamah) ===
              formatTimeAMPM(bb2.Maghrib_Iqamah) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "150px",
                    background: "#ffffffff",
                  }}
                >
                  <span>
                    Maghrib-Iqama <br /> &nbsp;
                    {formatTimeAMPM(bb2.Maghrib_Iqamah)} &nbsp;
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "150px",

                    background: "#F65A83",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Maghrib-Iqama <br />
                    {/* {formatTimeAMPM(bb2.Maghrib_Iqamah)} */}
                    {formatTimeAMPM(bb2.Maghrib_Iqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      formatTimeAMPM(bb2.Maghrib_Iqamah)
                    )}
                  </span>
                </td>
              )}
              {/* <td
                    style={{
                      border: "1px solid #dddddd",
                    }}
                  >
                    {formatTimeAMPM(bb2.Isha)}
                  </td> */}
              {formatTimeAMPM(bb.Isha_Iqamah) ===
              formatTimeAMPM(bb2.Isha_Iqamah) ? (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",

                    background: "#ffffffff",
                  }}
                >
                  <span>
                    {" "}
                    Isha-Iqama <br /> {formatTimeAMPM(bb2.Isha_Iqamah)}{" "}
                  </span>
                </td>
              ) : (
                <td
                  style={{
                    border: "1px solid #dddddd",
                    textAlign: "center",
                    fontFamily: "Quicksand, sans-serif",
                    width: "120px",

                    background: "#F65A83",
                  }}
                >
                  <span
                    style={{
                      // width: "100px",
                      color: "white",
                    }}
                  >
                    Isha-Iqama <br />
                    {formatTimeAMPM(bb2.Isha_Iqamah) === "12:NaN AM" ? (
                      <marquee>Update Iqamah time in web.whatsapp.com</marquee>
                    ) : (
                      formatTimeAMPM(bb2.Isha_Iqamah)
                    )}
                  </span>
                </td>
              )}
            </tr>
          </table>
        </div>
        <div
          className="right"
          style={{
            width: "40%",
            height: "100vh",
            filter: "drop-shadow(0 0 2px #6F47D3)",

            // background: "#316997ff",
            // background: "#FFD93D",
            background: "#0070bb",
            color: "black",
            // border: "2px solid red",
            float: "left",
          }}
        >
          <div
            className="1"
            style={{
              height: "37%",
              // background: "pink",
              borderBottom: "1px solid #dddddd",
            }}
          >
            <h2
              style={{
                marginTop: "-6px",
                textAlign: "center",
                fontSize: "45px",
                color: "white",
              }}
            >
              NOW
            </h2>
            <p
              style={{
                marginTop: "-50px",
                fontSize: "100px",
                fontStyle: "bold",
                textAlign: "center",
                fontFamily: "Space Mono, monospace",
                letterSpacing: -7,
                color: "white",
              }}
              className="ClockFont"
            >
              {/* <b>56:56:56 PM</b> <br /> */}
              <b>{formatTime(currentTime)}</b>
            </p>
            <p
              style={{
                marginTop: "-90px",
                fontSize: "40px",
                fontFamily: "Quicksand, sans-serif",
                color: "white",
                textAlign: "center",
              }}
            >
              {dayName}, {todaysDateIs}
              <br />
            </p>
            <p
              style={{
                marginTop: "-40px",
                color: "white",
                fontFamily: "Quicksand, sans-serif",
                fontSize: "35px",
                textAlign: "center",
              }}
            >
              {/* <b>{hijriDate}</b> */}
              {writeIslamicDate()}

              <br />
            </p>
          </div>
          <div
            className="2"
            style={{
              height: "37%",
              borderBottom: "1px solid #dddddd",

              // background: "red",
            }}
          >
            <p
              style={{
                marginTop: "5px",
                textAlign: "center",
                fontFamily: "Quicksand, sans-serif",
                fontSize: "28px",
                color: "white",
              }}
            >
              &nbsp; The Call To Prayer Of&nbsp;<span>{nextPrayer.label}</span>
              {/* &nbsp; The Call To Prayer Of&nbsp;<span>{activeWindow.prayerName}</span> */}
              &nbsp;Is In
              {/* @&nbsp; */}
              <span
                style={{
                  fontSize: "30px",
                }}
              >
                {/* <b>{formatTimeAMPM(nextPrayer.time || 0)}</b> */}
              </span>
            </p>

            <p
              style={{
                marginTop: "-40px",
                fontSize: "105px",
                textAlign: "center",
                color: "white",

                fontFamily: "Space Mono, monospace",
                letterSpacing: -8,
              }}
              className="ClockFont"
            >
              -<b>{isPlayingAzan ? "🔊 Playing Azan..." : countdown}</b>
              <br />
            </p>
            <p
              style={{
                marginTop: "-135px",
                filter: "drop-shadow(0 0 2px #6F47D3)",
                // marginLeft: "20px",
                // marginLeft: "-260px",
                textAlign: "center",
                fontSize: "20px",
                color: "#0070bb",

                // marginTop: "-66px",
                // fontSize: "89px",
                // textAlign: "center",
                // fontFamily: "Space Mono, monospace",
                // letterSpacing: -5,
              }}
            >
              <span
                style={{
                  // marginTop: "-135px",
                  marginLeft: "70px",
                  borderRadius: "6px",

                  textAlign: "center",
                  fontSize: "20px",
                  background: "white",
                  // filter: "drop-shadow(0 0 2px #6F47D3)",

                  // marginTop: "-66px",
                  // fontSize: "89px",
                  // textAlign: "center",
                  // fontFamily: "Space Mono, monospace",
                  // letterSpacing: -5,
                }}
              >
                &nbsp; SECONDS &nbsp;
              </span>
              <span
                style={{
                  // marginTop: "-135px",
                  marginLeft: "-270px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontSize: "20px",
                  background: "white",
                  // filter: "drop-shadow(0 0 2px #6F47D3)",

                  // marginTop: "-66px",
                  // fontSize: "89px",
                  // textAlign: "center",
                  // fontFamily: "Space Mono, monospace",
                  // letterSpacing: -5,
                }}
              >
                &nbsp; MINUTES &nbsp;
              </span>
              <span
                style={{
                  // marginTop: "-135px",
                  marginLeft: "-260px",
                  borderRadius: "6px",

                  textAlign: "center",
                  fontSize: "20px",
                  background: "white",
                  // filter: "drop-shadow(0 0 2px #6F47D3)",

                  // marginTop: "-66px",
                  // fontSize: "89px",
                  // textAlign: "center",
                  // fontFamily: "Space Mono, monospace",
                  // letterSpacing: -5,
                }}
              >
                &nbsp;&nbsp; HOURS &nbsp;&nbsp;
              </span>
            </p>
            <div
              className="main-container-flex"
              style={{
                height: "40%",
                // borderBottom: "1px solid #dddddd",
                // background: "red",
                marginTop: "-8px",
              }}
            >
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "30px",
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",

                  // background: "pink",
                }}
              >
                SUN-RISE: {formatTimeAMPM(bb.SUNRISE)}
              </div>
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "30px",
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",

                  // background: "pink",
                }}
              >
                IMSAK: {formatTimeAMPM(bb.Fajr)}
              </div>
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "30px",
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",
                  textAlign: "center",
                  // background: "blue",
                }}
              >
                SUN-SET: {formatTimeAMPM(bb.Maghrib)}
              </div>
              <div
                className="part-flex"
                style={{
                  width: "25%",
                  // borderBottom: "1px solid #dddddd",
                  fontSize: "30px",
                  color: "white",

                  // background: "pink",
                }}
              >
                IFTAR: {formatTimeAMPM(bb.Maghrib)}
              </div>
            </div>
          </div>
          <div
            className="3"
            style={{
              height: "26%",
              // background: "black",
            }}
          >
            <div
              style={{
                height: "80%",
                // borderBottom: "1px solid #dddddd",

                // background: "red",
              }}
            >
              <div
                className="box"
                style={{
                  marginTop: "8px",
                  marginLeft: "8px",

                  width: 190,
                  height: 185,
                  float: "left",
                  textAlign: "center",
                  backgroundSize: "cover", // Optional: Adjust how the image is sized
                  backgroundImage: `url(${paypal})`,
                  // height: "100vh",
                  backgroundPosition: "center",
                  // textShadow: "5px 2px #558abb",
                  backgroundRepeat: "no-repeat",
                  // backgroundColor: "rgba(0, 0, 0, 0.5)",

                  // backgroundColor: "#3F4F44",

                  // color: "white",
                  // marginLeft: "-5px",
                }}
              ></div>

              <div
                className="box"
                style={{
                  marginTop: "8px",
                  marginRight: "8px",
                  width: 185,
                  height: 185,
                  float: "right",
                  textAlign: "center",
                  backgroundSize: "cover", // Optional: Adjust how the image is sized
                  backgroundImage: `url(${zelle})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  // height: "100vh",
                  // textShadow: "5px 2px #558abb",
                  // backgroundColor: "rgba(0, 0, 0, 0.5)",

                  // backgroundColor: "#3F4F44",

                  // color: "white",
                  // marginLeft: "-5px",
                }}
              ></div>
            </div>
            <br />
            <div
              style={{
                height: "20%",
                // borderBottom: "1px solid #dddddd",

                // background: "red",
              }}
            >
              <p
                style={{
                  // width: "100%",
                  // fontSize: "15px",
                  marginTop: "1px",
                  fontFamily: "Quicksand, sans-serif",
                  marginLeft: "8px",
                  // fontWeight: "bold",
                  // textAlign: "center",
                  color: "white",
                }}
              >
                <b>
                  Application Developer:{" "}
                  <span
                    style={{
                      fontSize: "15px",
                    }}
                  >
                    MEHDI HASAN
                  </span>{" "}
                  || 845.514.8834 || Message To Suggest.
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

//⬆️⬆️🆙🆙⬆️⬆️🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝 up all for countdown for azan code 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝⬆️⬆️🆙🆙⬆️⬆️

export default App;
